// extracted by mini-css-extract-plugin
export var lg = "_40-4";
export var md = "_40-3";
export var sm = "_40-2";
export var xs = "_40-1";
export var xxs = "_40-0";